import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useDatePickerActionBarClassNames } from './hooks/useDatePickerActionBarClassNames';
import { useDatePickerActionBar } from './hooks/useDatePickerActionBar';
import { DatePickerActionBarRoot, DatePickerActionBarButton } from './style';
import { DATE_PICKER_ACTION_BAR_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
export var DatePickerActionBar = forwardRef(function DatePickerActionBar(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var theme = useComponentTheme(DATE_PICKER_ACTION_BAR_CLASS_PREFIX);
  var classNameComponents = useDatePickerActionBarClassNames(DATE_PICKER_ACTION_BAR_CLASS_PREFIX, className);

  var _useDatePickerActionB = useDatePickerActionBar(props, ref),
      rootProps = _useDatePickerActionB.rootProps,
      cancelButtonProps = _useDatePickerActionB.cancelButtonProps,
      applyButtonProps = _useDatePickerActionB.applyButtonProps;

  return React.createElement(DatePickerActionBarRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(DatePickerActionBarButton, Object.assign({}, cancelButtonProps, {
    marginRight: 2,
    theme: theme,
    className: classNameComponents.ActionBarButton
  }), "Cancel"), React.createElement(DatePickerActionBarButton, Object.assign({}, applyButtonProps, {
    theme: theme,
    className: classNameComponents.ActionBarButton
  }), "Ok"));
});
DatePickerActionBar.defaultProps = {};